import type { PricingFeatureStrike } from "@/domains/subscription/plans";
import { billingPlans } from "@/domains/shared/apis/billingApi";

export type ApiPlanBenefit = {
    text: string;
    strike?: boolean;
};

export type ApiSubscriptionPlan = {
    id: string;
    name: string;
    versionId: string;
    versionNumber: number;
    priceBrl: number;
    priceLabel: string;
    periodLabel: string;
    trialDays: number;
    patientLimit: number | null;
    storageLimitBytes: number;
    includesFileStorage: boolean;
    benefits: ApiPlanBenefit[];
    description: string;
    cta: string;
    enabled: boolean;
};

export async function fetchSubscriptionPlans(): Promise<ApiSubscriptionPlan[]> {
    const data = await billingPlans();
    return Array.isArray(data) ? data : [];
}

export function mapBenefits(benefits: ApiPlanBenefit[]): (string | PricingFeatureStrike)[] {
    return benefits.map((b) => (b.strike ? { text: b.text, strike: true } : b.text));
}
